import MainLayout from "../../../../components/mainLayout";
import { PAGES } from "../../../../routes";
import audio from "../../../../assets/audio/17.mp3"
export default function P1() {
    return (
        <MainLayout
            title="Spotkanie gęsiarzy"
            question=""
            audio={audio}
            answers={{
                ans1: "Może potrzebujecie pomocy przy podkuwaniu gęsi?",
                ans2: "Kim jest Samotny Olęder?",
            }}
            links={{
                link1: PAGES.p32,
                link2: PAGES.p33,
            }}
            content={
                <div>
                    <p>
                        Obchodzisz miasteczko i włóczysz się po okolicznych polach. Nieopodal rzeki zauważasz na łące stado gęsi. Pośród długich ptasich szyj widać dwóch mężczyzn w kaszkietach. To gęsiarze!
                    </p>
                    <ul>
                        <li>Witam serdecznie królów gęsi! – przychodzi ci do głowy, że może trzeba zacząć rozmowę tak, jak wczoraj zagadał do Emila brodaty Garfunkel. – Może potrzebujecie panowie pomocnika? Pracy szukam.</li>
                    </ul>
                    <p>
                        Zdziwieni mężczyźni przerywają rozmowę i przyglądają ci się uważnie. Po chwili żylasty gęsiarz mówi do kolegi z uśmiechem:
                    </p>
                    <ul>
                        <li>
                            A to lisek chytrusek, gąski mu się zachciewa, nie Bronek? – złośliwy żart przecina niezręczną ciszę.
                        </li>
                    </ul>
                    <p>
                        Drugi gęsiarz jest od niego wyższy. Widać, że ma dużo szacunku do kolegi po fachu, bo zaraz przytakuje: – Dalibóg, że z Niemiec się tacy przekradają…  Dopiero wrzesień, a oni już chcą kraść gęsi na święta… Ktoś ty?
                    </p>
                    <ul>
                        <li>
                            Jestem tu od wczoraj, śpię u Emila w Tarszewie.
                        </li>
                        <li>Może i z samego Berlina wysłali po nasze gęsi! – drwi żylasty.</li>
                        <li>Ja nic nie wiem, przysięgam! – śmieje się do niego Bronek. – Przemycam tylko spirytus, czysty jak woda z Warty!</li>
                    </ul>
                    <p>
                        Gęsiarze zaczynają bawić się na tyle dobrze, że niemal zapominają o twojej obecności. Postanawiasz im o sobie przypomnieć, zwracając się z pytaniem.
                    </p>
                </div>
            }
        />

    );
}